import styled from 'styled-components';
export const FormControlWrapper = styled.div.withConfig({
  displayName: "EditPropertyWrapperstyle__FormControlWrapper",
  componentId: "sc-7q3bt2-0"
})(["min-width:200px;label{padding:0;}span{font-size:", ";font-weight:", ";}", ""], ({
  theme
}) => theme.typography['detail-100'].fontSize, ({
  theme
}) => theme.typography['body-300'].fontWeight, ({
  validationError,
  theme
}) => validationError ? `
    input {
      border-bottom-color: ${theme.color['border-alert-default']};

      &:hover {
        border-bottom-color: ${theme.color['border-alert-default']};
      }
    }
  ` : '');